



































import { mixins } from 'vue-class-component'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppSteps from '@/components/AppSteps.vue'
import { Case } from '@/modules/Case/interfaces/case'
import { Account } from '@/modules/Account/interfaces/account'
import TaskFormInfo from '@/modules/Task/components/forms/TaskFormInfo.vue'
import TaskFormRelated from '@/modules/Task/components/forms/TaskFormRelated.vue'
import { Task, TaskInfoInput, TaskRelatedInput, TaskRelationInput } from '@/modules/Task/interfaces/task'
import SearchUser from '@/mixins/search-queries/search-user'
import { User } from '@/modules/User/interfaces/user'
import { taskPriorityKeys, taskRelationTypeKeys } from '@/modules/Task/helpers/task'
import { newTask, editTask } from '@/modules/Task/gql/task.gql'
import { Policy } from '@/modules/Policy/interfaces/policy'

@Component({
  components: {
    AppDialog,
    AppSteps,
    TaskFormInfo,
    TaskFormRelated
  }
})
export default class TaskForm extends mixins(SearchUser) {
  @Prop(Boolean) value!: boolean
  @Prop(Number) readonly step!: number
  @Prop(String) readonly title!: string
  @Prop({ type: Object as () => Task }) readonly task!: Task
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy
  @Prop({ type: Object as () => Account }) readonly account!: Account

  showDialog = false
  loading = false

  stepIndex = 0
  steps = [
    ['Task Info', 620, 666],
    ['Related To', 600, 286]
  ]

  infoInput: TaskInfoInput = {
    title: '',
    priorityIdx: 2,
    assignedToList: null,
    notes: '',
    dueDate: '',
    reminderDate: ''
  }

  relatedInput: TaskRelatedInput[] = [
    {
      typeIdx: 0,
      cell: {},
      lock: false
    }
  ]

  get stepItems () {
    return this.steps.map(st => st[0])
  }

  get showBackBtn () {
    return this.stepIndex > 0
  }

  get canAdd () {
    return this.stepIndex === 1
  }

  get confirmText () {
    return this.stepIndex < this.steps.length - 1
      ? 'Next'
      : this.task
        ? 'Save'
        : 'Create'
  }

  @Watch('value')
  onValueChanged (val: boolean) {
    this.showDialog = val
    if (val) {
      this.resetStep()
      this.initInput()
    }
  }

  addRelatedCell () {
    const item: TaskRelatedInput = {
      typeIdx: 0,
      cell: {}
    }
    if (this.relatedInput.length > 0) {
      const stepsList = this.steps.concat()
      stepsList[1][2] = +stepsList[1][2] + 77 > 666 ? 666 : +stepsList[1][2] + 77
      this.steps = stepsList.concat()
    }

    this.relatedInput.push(item)
  }

  deleteRelatedCell (idx: number) {
    this.relatedInput.splice(idx, 1)
    if (this.relatedInput.length < 6) {
      const stepsList = this.steps.concat()
      stepsList[1][2] = +stepsList[1][2] - 77 > 286 ? +stepsList[1][2] - 77 : 286
      this.steps = stepsList.concat()
    }
  }
  resetStep () {
    this.stepIndex = this.step
  }

  initInput () {
    if (this.task) {
      const { title, priority, assignedTo, notes, dueDate, reminderDate, policies, cases, accounts } = this.task
      const assignedToList: number[] = []
      this.$R.forEach((item: User) => {
        const itemIdx = this.candidatesUser.findIndex(user => +user.id === +item.id)
        if (itemIdx > -1) {
          assignedToList.push(itemIdx)
        }
      }, assignedTo)
      let priorityIdx = 2
      if (priority) {
        priorityIdx = taskPriorityKeys.findIndex(priorityItem => priorityItem === priority)
      }
      this.infoInput = {
        title,
        priorityIdx,
        assignedToList,
        notes,
        dueDate: dueDate + '',
        reminderDate: reminderDate + ''
      }
      const relations: TaskRelatedInput[] = []
      if (cases) {
        this.$R.forEach((item: Case) => {
          const cellTypeIdx = taskRelationTypeKeys.findIndex(type => type === 'CASE')
          const cell: TaskRelatedInput = {
            typeIdx: cellTypeIdx,
            cell: {
              id: +item.id,
              name: item.inquiryName
            }
          }
          relations.push(cell)
        }, cases)
      }
      if (policies) {
        this.$R.forEach((item: Policy) => {
          const cellTypeIdx = taskRelationTypeKeys.findIndex(type => type === 'POLICY')
          const cell: TaskRelatedInput = {
            typeIdx: cellTypeIdx,
            cell: {
              id: +item.id,
              name: item.policyName
            }
          }
          relations.push(cell)
        }, policies)
      }
      if (accounts) {
        this.$R.forEach((item: Account) => {
          const cellTypeIdx = taskRelationTypeKeys.findIndex(type => type === 'ACCOUNT')
          const cell: TaskRelatedInput = {
            typeIdx: cellTypeIdx,
            cell: {
              id: +item.id,
              name: item.name
            }
          }
          relations.push(cell)
        }, accounts)
      }
      if (relations.length === 0) {
        relations.push({
          typeIdx: 0,
          cell: {}
        })
      }
      this.relatedInput = relations.concat()
      const stepsList = this.steps.concat()
      const newHeight = ((this.relatedInput.length - 1) * 77) + 286
      stepsList[1][2] = newHeight > 666 ? 666 : newHeight
      this.steps = stepsList.concat()
    } else {
      if (!this.caseInfo && !this.policy && !this.account) {
        this.clearForm()
      }

      this.relatedInput = []

      if (this.caseInfo) {
        const cellTypeIdx = taskRelationTypeKeys.findIndex(type => type === 'CASE')
        const cell: TaskRelatedInput = {
          typeIdx: cellTypeIdx,
          cell: {
            id: +this.caseInfo.id,
            name: this.caseInfo.inquiryName
          },
          lock: true
        }
        this.relatedInput.push(cell)
      }
      if (this.policy) {
        const cellTypeIdx = taskRelationTypeKeys.findIndex(type => type === 'POLICY')
        const cell: TaskRelatedInput = {
          typeIdx: cellTypeIdx,
          cell: {
            id: +this.policy.id,
            name: this.policy.policyName
          },
          lock: true
        }
        this.relatedInput.push(cell)
      }
      if (this.account) {
        const cellTypeIdx = taskRelationTypeKeys.findIndex(type => type === 'ACCOUNT')
        const cell: TaskRelatedInput = {
          typeIdx: cellTypeIdx,
          cell: {
            id: +this.account.id,
            name: this.account.name
          },
          lock: true
        }
        this.relatedInput.push(cell)
      }

      const stepsList = this.steps.concat()
      const newHeight = ((this.relatedInput.length - 1) * 77) + 286
      stepsList[1][2] = newHeight > 666 ? 666 : newHeight
      this.steps = stepsList.concat()
    }
  }

  handleStepClick (index: number) {
    if (!this.task) {
      return
    }

    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    this.stepIndex = index
  }

  handleValidate () {
    const { stepIndex, steps } = this
    const refName = steps[stepIndex][0] as string
    return (this.$refs[refName] as Vue & {
      validate: () => null | { [key: string]: number | string }
    }).validate()
  }

  handleConfirm (event: Event, finishAhead = false) {
    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    if (this.stepIndex === this.steps.length - 1 || finishAhead) {
      this.loading = true
      if (this.task) {
        this.handleUpdate()
      } else {
        this.handleCreate()
      }
    } else {
      this.stepIndex += 1
    }
  }

  handleBack () {
    this.stepIndex -= 1
  }

  async handleCreate () {
    const { title, priorityIdx, dueDate, reminderDate, assignedToList, notes } = this.infoInput
    const assignedToIds: number[] = []
    if (assignedToList) {
      this.$R.forEach((idx: number) => {
        const user = this.candidatesUser[idx]

        if (user) {
          assignedToIds.push(+user.id)
        }
      }, assignedToList)
    }

    const relations: TaskRelationInput[] = []
    this.$R.forEach((item: TaskRelatedInput) => {
      if (item.typeIdx > -1 && item.cell.id) {
        const cell: TaskRelationInput = {
          type: taskRelationTypeKeys[item.typeIdx],
          id: item.cell.id
        }
        relations.push(cell)
      }
    }, this.relatedInput)

    try {
      const res = await this.$apollo.mutate({
        mutation: newTask,
        variables: {
          input: {
            title,
            dueDate,
            reminderDate,
            priority: taskPriorityKeys[priorityIdx],
            notes,
            assignedToIds,
            relations
          }
        }
      })
      this.clearForm()
      this.onSuccess('Create the new task successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  async handleUpdate () {
    if (!this.task) {
      return
    }
    const { id } = this.task
    const { title, priorityIdx, dueDate, reminderDate, assignedToList, notes } = this.infoInput
    const assignedToIds: number[] = []
    this.$R.forEach((idx: number) => {
      const user = this.candidatesUser[idx]
      if (user) {
        assignedToIds.push(+user.id)
      }
    }, assignedToList)

    const relations: TaskRelationInput[] = []
    this.$R.forEach((item: TaskRelatedInput) => {
      if (item.typeIdx > -1 && item.cell.id) {
        const cell: TaskRelationInput = {
          type: taskRelationTypeKeys[item.typeIdx],
          id: item.cell.id
        }
        relations.push(cell)
      }
    }, this.relatedInput)

    try {
      const res = await this.$apollo.mutate({
        mutation: editTask,
        variables: {
          input: {
            title,
            dueDate,
            reminderDate: reminderDate && reminderDate !== 'null' ? reminderDate : '',
            priority: taskPriorityKeys[priorityIdx],
            notes,
            assignedToIds,
            relations
          },
          taskId: +id
        }
      })
      this.clearForm()
      this.onSuccess('Update task successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  clearForm () {
    this.loading = false

    this.infoInput = {
      title: '',
      priorityIdx: 2,
      dueDate: '',
      reminderDate: '',
      notes: '',
      assignedToList: null
    }

    this.relatedInput = [
      {
        typeIdx: 0,
        cell: {}
      }
    ]
  }

  @Emit('cancel')
  handleCancel () {
    this.$emit('input', false)
    this.clearForm()
  }

  @Emit('success')
  onSuccess (msg = '') {
    this.$emit('input', false)
    this.resetStep()
    if (msg) {
      showNotification({
        msg,
        type: SnackType.Success
      })
    }
  }
}
